export default "__VITE_ASSET__wHceMpfw__"